import { render, staticRenderFns } from "./ProductInfoBottom.vue?vue&type=template&id=40c25992&scoped=true"
import script from "./ProductInfoBottom.vue?vue&type=script&lang=js"
export * from "./ProductInfoBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c25992",
  null
  
)

export default component.exports